module.exports = __webpack_public_path__ + "img/background-work.950be903.png";